import { AddTokenToWalletButton } from '@/components/add-token-to-wallet-button';
import { NavButton } from '@/components/nav-button';
import { AppRoute, ROYCO_DOMAIN_URL } from '@/constants/shared';
import { Box, Card, HStack, Heading, Spacer, VStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { useCurrentVault } from './hooks/useCurrentVault';

type DepositAndWithdrawalFrameProps = {
  title: string;
  description?: string;
} & PropsWithChildren;
export const DepositsAndWithdrawalFrame = ({ children, title, description }: DepositAndWithdrawalFrameProps) => {
  const { chainId, marketId, vaultAddress, vaultKey, vault } = useCurrentVault();
  const withdrawToken = Object.values(
    vault?.withdraw.sourceChains[chainId].destinationChains[chainId].wantTokens ?? {},
  )?.[0];
  return (
    <Box>
      <HStack mb={10} gap={4}>
        <NavButton direction="bk" href={`${AppRoute.Optimizer}/${vaultAddress}`} h={8} w={12} bgColor="bg" />
        <Spacer flex={1} />
        {withdrawToken && (
          <AddTokenToWalletButton
            variant="outline"
            bgColor="bg"
            tokenSymbol={withdrawToken.symbol}
            tokenAddress={withdrawToken.address}
            tokenDecimals={withdrawToken.decimals}
            hideBelow="md"
          />
        )}
        <AddTokenToWalletButton
          variant="outline"
          bgColor="bg"
          tokenSymbol={vaultKey}
          tokenAddress={vaultAddress}
          tokenDecimals={vault?.token.decimals}
          hideBelow="md"
        />
        <NavButton href={`${ROYCO_DOMAIN_URL}/market/${chainId}/0/${marketId}`} target="blank" bgColor="bg">
          Royco Market <FiArrowUpRight />
        </NavButton>
      </HStack>
      <Card.Root borderColor="bg.muted" borderRadius="2xl" overflow="hidden" hideBelow="md">
        <Card.Header borderBottomWidth="thin" textAlign="center" pb={6} fontWeight="500">
          <Heading>{title}</Heading>
          {description && (
            <Heading size="lg" fontWeight="500" color="fg.muted">
              {description}
            </Heading>
          )}
        </Card.Header>
        <Card.Body bgColor="#F0F3F6">
          <VStack alignItems="center">{children}</VStack>
        </Card.Body>
      </Card.Root>
      <VStack hideFrom="md">{children}</VStack>
    </Box>
  );
};
